import { storeToRefs } from 'pinia';
import { computed, onMounted } from 'vue';

import { MDM_TYPES } from '@/constants/mdm';
import { useFeedsStore, useSourcesStore } from '@/stores';

import useAuth from './useAuth';

export function usePreferredCRMFeed() {
  const feedsStore = useFeedsStore();
  const { crmFeeds } = storeToRefs(feedsStore);
  const sourcesStore = useSourcesStore();
  const { sources } = storeToRefs(sourcesStore);
  const { preferredCRMFeedId } = useAuth();

  const preferredCRMFeed = computed(() => {
    if (crmFeeds.value.length === 0) {
      return null;
    }
    if (!preferredCRMFeedId.value) {
      return crmFeeds.value[0];
    }
    return crmFeeds.value.find((f) => f.id === preferredCRMFeedId.value);
  });

  function getSourceByMdm(mdmType: string) {
    return sources.value.find(
      (s) => s.feed_id === preferredCRMFeed.value?.id && s.mdm_type === mdmType,
    );
  }
  const preferredCRMFeedSource = computed(() => {
    if (!preferredCRMFeed.value) return null;
    return getSourceByMdm(MDM_TYPES.ACCOUNT);
  });

  onMounted(async () => {
    await Promise.all([feedsStore.readySync, sourcesStore.readySync]);
  });

  return {
    preferredCRMFeed,
    preferredCRMFeedSource,
    getSourceByMdm,
  };
}
